import React, { useId } from "react";
import { cn } from "../../utils/cn";

interface TextareaProps
	extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: React.ReactNode;
	description?: React.ReactNode;
	error?: React.ReactNode;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	(
		{
			className,
			label,
			description,
			error,
			required = false,
			id,
			...props
		},
		ref,
	) => {
		const generatedId = useId();
		const textareaId = id ?? generatedId;

		return (
			<div className="space-y-2">
				{label && (
					<label
						htmlFor={textareaId}
						className="text-sm font-medium text-foreground"
					>
						{label}
						{required && <span className="text-destructive ml-1">*</span>}
					</label>
				)}
				{description && (
					<p className="text-sm text-muted-foreground">{description}</p>
				)}
				<textarea
					ref={ref}
					id={textareaId}
					className={cn(
						"flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
						error && "border-destructive",
						className,
					)}
					required={required}
					{...props}
				/>
				{error && (
					<p className="text-sm text-destructive">{error}</p>
				)}
			</div>
		);
	},
);

Textarea.displayName = "Textarea";

export default Textarea;
